/* HCX galerie D2 — fiche produit product.hce uniquement (chargé par layout/theme.liquid).
   ORDINATEUR (>= 990 px) : deux flèches autour de la grande photo (et sur la photo en mobile). Le thème n'affiche qu'un média à la
   fois et change de média quand on clique une vignette : la flèche clique la vignette voisine.
   MOBILE / TABLETTE (<= 989 px) : des points sous la photo, synchronisés avec le balayage horizontal
   du thème. Aucun contenu n'est créé hors de <media-gallery>. */
(function () {
  function init() {
    var gal = document.querySelector('media-gallery');
    if (!gal || gal.dataset.hcxGal) return;
    var main = gal.querySelector('.lm-slider-main');
    var list = gal.querySelector('.product__media-list');
    if (!main || !list) return;
    gal.dataset.hcxGal = '1';
    var wide = window.matchMedia('(min-width: 990px)');

    /* ---- flèches (ordinateur) ---- */
    function thumbButtons() {
      return [].slice.call(gal.querySelectorAll('.thumbnail-list__item')).filter(function (li) { return li.offsetWidth > 0; })
        .map(function (li) { return li.querySelector('button'); }).filter(Boolean);
    }
    function step(dir) {
      if (!wide.matches) {
        /* mobile / tablette : pas de vignettes, on fait défiler le curseur du thème d'une photo */
        var s = slides();
        if (s.length < 2) return;
        var c = (current(s) + dir + s.length) % s.length;
        list.scrollTo({ left: s[c].offsetLeft - s[0].offsetLeft, behavior: 'smooth' });
        return;
      }
      var btns = thumbButtons();
      if (btns.length < 2) return;
      var i = btns.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
      if (i < 0) i = 0;
      var next = btns[(i + dir + btns.length) % btns.length];
      next.click();
      if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function arrow(dir, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hcx-gal-arrow hcx-gal-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"></path></svg>';
      b.addEventListener('click', function () { step(dir); });
      main.appendChild(b);
      return b;
    }
    var prev = arrow(-1, 'Photo précédente', 'm15 6-6 6 6 6');
    var next = arrow(1, 'Photo suivante', 'm9 6 6 6-6 6');

    /* ---- points (mobile / tablette) ---- */
    var dots = document.createElement('div');
    dots.className = 'hcx-gal-dots';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', 'Photos du produit');
    main.insertAdjacentElement('afterend', dots);

    function slides() {
      return [].slice.call(list.children).filter(function (li) { return li.offsetWidth > 0; });
    }
    function current(s) {
      var x = list.scrollLeft, best = 0, d = Infinity;
      s.forEach(function (li, i) { var v = Math.abs((li.offsetLeft - s[0].offsetLeft) - x); if (v < d) { d = v; best = i; } });
      return best;
    }
    /* 2026-09-22, Raji : sur mobile les vignettes sont en colonne à gauche (hcx-design-d2.css). Elles suivent la photo
       affichée : la colonne défile pour amener la vignette courante au centre, et celle-ci est encadrée. */
    function syncThumbs(c) {
      if (wide.matches) return;
      var col = gal.querySelector('.thumbnail-list');
      if (!col) return;
      var items = [].slice.call(col.children);
      items.forEach(function (li, i) { li.classList.toggle('hcx-thumb-active', i === c); });
      /* 2026-09-22 : on suit la vignette que LE THÈME marque (aria-current) ; les index de la liste et des
         diapositives ne coïncident pas (vignettes masquées). items[c] n'est qu'un repli. */
      var marquee = col.querySelector('[aria-current="true"]');
      var li = marquee ? marquee.closest('li') : items[c];
      if (!li || col.scrollHeight <= col.clientHeight) return;
      var top = li.offsetTop - (col.clientHeight - li.offsetHeight) / 2;
      col.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    function paint() {
      var s = slides(), c = current(s);
      [].forEach.call(dots.children, function (b, i) { if (i === c) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      syncThumbs(c);
    }
    function build() {
      var s = slides();
      var show = !wide.matches && s.length > 1;
      dots.hidden = !show;
      prev.hidden = next.hidden = wide.matches ? thumbButtons().length < 2 : s.length < 2;
      if (!show) { dots.textContent = ''; return; }
      if (dots.children.length !== s.length) {
        dots.textContent = '';
        s.forEach(function (li, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'hcx-gal-dot';
          b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + s.length);
          b.addEventListener('click', function () {
            var now = slides();
            if (now[i]) list.scrollTo({ left: now[i].offsetLeft - now[0].offsetLeft, behavior: 'smooth' });
          });
          dots.appendChild(b);
        });
      }
      paint();
    }

    var raf = 0;
    list.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; paint(); }); }, { passive: true });
    /* changement de coloris : le thème remet la photo du coloris en tête et change les classes */
    /* Mesuré à 390 px : au changement de coloris le thème remet la photo du coloris en tête de liste,
       mais le défilement reste où il était (scrollLeft 390) : le client choisit « Bleu » et voit la
       2e photo. On ramène donc la liste sur la photo du coloris actif, uniquement quand CE média
       change (un balayage au doigt ne change pas `is-active`, il n'est donc jamais contrarié). */
    function variantId() {
      var li = list.querySelector('.product__media-item--variant.is-active');
      return li ? (li.id || li.dataset.mediaId || '') : '';
    }
    var lastVariant = variantId();
    function recenter() {
      var id = variantId();
      if (id === lastVariant) return;
      lastVariant = id;
      if (wide.matches) return;
      var s = slides(), li = list.querySelector('.product__media-item--variant.is-active');
      if (li && s.length) list.scrollTo({ left: li.offsetLeft - s[0].offsetLeft });
    }
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { build(); recenter(); paint(); }, 120); })
      .observe(list, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });
    if (wide.addEventListener) wide.addEventListener('change', build); else wide.addListener(build);
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 150); });
    build();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Retouche 25 (Raji, 2026-09-18) : libellé « Couleur » dupliqué (« Couleur: Café Rose »).
   Cause, relevée dans sections/main-product.liquid (thème, hors périmètre D2) : pour une option
   COULEUR, le thème écrit `<span id="atc selected-couleur">{{ valeur au chargement }}</span>`.
   L'espace dans cet id le rend introuvable pour son propre script de mise à jour, qui cherche
   `#selected-couleur` (sans le préfixe « atc ») : ce span reste donc figé à la valeur affichée au
   chargement de la page. Un AUTRE bout du thème, lui, ajoute bien un nœud de texte juste après ce
   span à chaque changement (taille OU couleur) — et le laisse s'accumuler, d'où les doublons
   observés (« Rose Rose », « Café Rose »…). Corrigé ici sans toucher au thème : après chaque
   changement, on réécrit le span figé avec la vraie valeur cochée et on supprime les nœuds de
   texte parasites ajoutés à sa suite. Portée : uniquement `.c4-option--couleur`, l'option Taille
   n'est pas concernée (son span a un id bien formé et se met à jour correctement). */
(function () {
  function fixerLibelleCouleur() {
    document.querySelectorAll('.c4-option--couleur').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend, .form__label');
      if (!legend) return;
      var span = legend.querySelector('span[id^="atc selected-"], span[id^="selected-"]');
      if (!span) return;
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked && checked.value) span.textContent = ' ' + checked.value;
      var node = span.nextSibling;
      while (node) {
        var next = node.nextSibling;
        if (node.nodeType === 3 && node.textContent.trim()) node.remove();
        node = next;
      }
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.c4-option--couleur, .c4-option--taille')) {
      setTimeout(fixerLibelleCouleur, 80);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixerLibelleCouleur);
  else fixerLibelleCouleur();
})();